var strings = {
    notifications: {
        attemptToCollectDebt: 'There is an attempt to collect a debt and any information obtained will be used for that purpose.',
        attentionRequired: 'Your attention is required.',
        autopayFutureNotify: 'Autopay of %minAmountDue% will occur in %daysToDueDate% days.',
        autopayTodayNotify: 'Autopay of %minAmountDue% will occur today.',
        autopayTomorrowNotify: 'Autopay of %minAmountDue% will occur in 1 day.',
        closedWithBalance: 'This account is closed.',
        enrolledPaymentPlan: 'Enrolled in payment plan.',
        issueWithAccount: 'There is an issue with your account. Please contact customer service at 1-800-542-5593.',
        loanPaidOffNotify: 'Congratulations, this loan is paid off!',
        minimizeNotification: 'Minimize Notification',
        noPaymentDueNotify: 'No minimum payment due.',
        notifications: 'Notifications',
        pastDueNotify: 'Your payment is past due.',
        pastDueNotifyMessage: 'This is an attempt to collect a debt and any information obtained will be used for that purpose.',
        paymentDueFutureNotify: 'Your payment is due in %numberOfDaysToDueDate% days.',
        paymentDueTodayNotify: 'Your payment is due today.',
        paymentDueTomorrowNotify: 'Your payment is due in 1 day.',
        paymentProcessingNotify: 'Your payment of %amountPaid% is processing.',
        paymentScheduledFutureNotify: 'Scheduled Payment of %payAmount% will occur in %numberOfDaysToDueDate% days.',
        paymentScheduledTodayNotify: 'Scheduled Payment of %payAmount% will occur today.',
        paymentScheduledTomorrowNotify: 'Scheduled Payment of %payAmount% will occur in 1 day.',
        registerAccountNotify: 'Register now to access your account.',
        waivedInterestPromotionExpired: 'This loan is outside of the Waived interest promotional period and is no longer eligible to have all interest waived.',
        promotionExpired: 'Promotional period expired.',
        waivedInterestPromotionExpiring: 'Waived Interest promotional period is expiring soon. In order to waive interest on this loan, you must make a payment(s) that total $%payOffBalance% by %promoEndDate%.',
        promotionExpiring: 'Promotional period expiring.',
        introRateLoanExpiring: 'Intro period expiring',
        introRateLoanExpired: 'Intro period expired',
        introRateLoanPromotionExpiring: 'Your intro period ends on %promoExpiryDate%. Pay off or pay more during your intro period to reduce interest paid over the life of the loan.',
        introRateLoanPromotionExpired: 'Your rate and payment have both increased. Go to your Details tab for more information.',
        loanApprovedStillProcessing: 'Your loan is approved but still processing. Loan details will be provided when available.',
    }
};
export default strings;
